import _Dialog from "@material-ui/core/esm/Dialog";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { variables } from 'swag-client-common/styles/variables-js';
import { Title } from './components/title';
import Content from './components/content';
import Footer from './components/footer';
import CSSClasses from './popup-dialog.scss';
const styles = () => {
  return createStyles({
    paper: {
      position: 'relative',
      borderRadius: variables.popupBorderRadius,
      maxWidth: 730,
      padding: '0 30px',
      backgroundColor: variables.colorBackgroundLightGray,
      overflowY: 'initial'
    }
  });
};

// default transition values stored here: https://next.material-ui.com/customization/transitions/
export const DEFAULT_POPUP_ENTER_TRANSITION = 225;
export const DEFAULT_POPUP_EXIT_TRANSITION = 195;
const DEFAULT_POPUP_TRANSITION = {
  enter: DEFAULT_POPUP_ENTER_TRANSITION,
  exit: DEFAULT_POPUP_EXIT_TRANSITION
};
const PopupDialogComponent = ({
  open,
  title = null,
  content = null,
  footer = null,
  children,
  dataPopup = '',
  contentClass = '',
  titleHeader = '',
  closeClass = '',
  popupClassName = '',
  classes = null,
  titleClasses = null,
  footerClasses = null,
  showCloseButton = true,
  fullScreen = false,
  disableScrollLock = true,
  TransitionProps = {},
  onClose = () => {
    /* empty */
  },
  transitionDuration = DEFAULT_POPUP_TRANSITION,
  keepMounted = false,
  closeStyles,
  isResponsive = false
}) => {
  return /*#__PURE__*/React.createElement(_Dialog, {
    open: open,
    onClose: onClose,
    classes: _objectSpread({}, classes ? classes : {}, {
      paper: classnames({
        [CSSClasses.rootResponsive]: isResponsive
      }, classes !== null && classes !== void 0 && classes.paper ? classes.paper : '')
    }),
    scroll: "body",
    className: classnames(CSSClasses.popupDialog, popupClassName),
    fullScreen: fullScreen,
    transitionDuration: transitionDuration,
    disableScrollLock: disableScrollLock,
    TransitionProps: TransitionProps,
    keepMounted: keepMounted
  }, /*#__PURE__*/React.createElement(Title, {
    classes: _objectSpread({}, titleClasses, {
      root: classnames(CSSClasses.titleRoot, titleClasses !== null && titleClasses !== void 0 && titleClasses.root ? titleClasses.root : '')
    }),
    showCloseButton: showCloseButton,
    onClose: onClose,
    titleHeader: classnames(CSSClasses.titleHeader, titleHeader),
    closeClass: closeClass,
    closeStyles: closeStyles
  }, title), /*#__PURE__*/React.createElement(Content, {
    className: classnames(CSSClasses.content, {
      [CSSClasses.contentResponsive]: isResponsive
    }, contentClass),
    "data-popup": dataPopup
  }, children || content), footer && /*#__PURE__*/React.createElement(Footer, {
    classes: footerClasses
  }, footer));
};
export const PopupDialog = withStyles(styles)(PopupDialogComponent);